/* eslint-disable no-nested-ternary */
import styled from 'styled-components';
import theme from '../../styles/defaultTheme';

export const StyledButton = styled.button`
    min-height: 44px;
    min-width: 176px;
    font-size: ${theme.font.size16};
    padding: auto 24px;
    border-radius: 8px;
    outline: none;
    border: none;
    font-weight: bold;
    font-family: inherit;
    cursor: pointer;
    margin: 32px 0 0 0;
    color: ${(props) => props.theme.whiteLink};

    @media (max-width: 900px) {
        width: 100%;
        margin: 10px 0;
    };


    ${({ type, disabled, contrastTheme }) =>
        type === 'primary' && disabled && !contrastTheme
            ? `
            background-color: #BCBCBC !important;
            color: #FFFFFF !important;
            cursor: not-allowed;
        `
            : type === 'primary' && disabled && contrastTheme
            ? `
            color: #FFFFFF !important;
            background-color: #000000 !important;
            border: 1px solid #FFFFFF !important;
            cursor: not-allowed;
        `
            : type === 'primary' && !disabled && contrastTheme
            ? `
            color: #000000 !important;
            background-color: #FFF333 !important;
        `
            : type === 'primary' && !disabled && !contrastTheme
            ? `
            background-color: #EC6E0C  !important;
            color: #FFFFFF !important;
        `
            : type === 'secondary' && disabled && !contrastTheme
            ? `
            background-color: transparent;
            color: #BCBCBC;
            border: 1px solid #BCBCBC;
            cursor: not-allowed;
            `
            : type === 'secondary' && disabled && contrastTheme
            ? `
            background-color: transparent;
            color: #FFFFFF;
            cursor: not-allowed;
            border: 1px solid #FFFFFF !important;
        `
            : type === 'secondary' && !disabled && !contrastTheme
            ? `
            background-color: transparent;
            color: #EC6E0C;
            border: 1px solid #EC6E0C  !important;`
            : type === 'secondary' && !disabled && contrastTheme
            ? `
            background-color: transparent;
            color: #FFF333;
            border: 1px solid #FFF333 !important;`
            : type === 'link' && disabled && !contrastTheme
            ? `
            background-color: transparent;
            color: #BCBCBC !important;
            cursor: not-allowed;
            `
            : type === 'link' && disabled && contrastTheme
            ? `
            background-color: transparent;
            color: #FFFFFF !important;
            cursor: not-allowed;
        `
            : type === 'link' && !disabled && !contrastTheme
            ? `
            background-color: transparent;
            color: #EC6E0C !important;`
            : type === 'link' && !disabled && contrastTheme
            ? `
            background-color: transparent;
            color: #FFF333 !important;`
            : ``}

`;
